module.exports = __webpack_public_path__ + "static/media/comment-alt-exclamation.4faf4b47.svg";